export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const blockingDelay = (ms = 500) => {
    const
        start = Date.now(),
        delay = ms; // msec
    let now = start;
    while (now - start < delay) {
        now = Date.now();
    }
};

export const getDomainName = (hostName) => hostName.split('.').slice(-2).join('.');
